<template>
    <div>
      <div class="content-block-title">Time limits</div>
      <div class="content-block-item">
        <div class="flex-between flex-v-center mb-2">
          <div class="content-block-subtitle mb-0">
            {{$lang.messages.settings.daily_limit.title}}&nbsp;
            <span v-tooltip="$lang.messages.settings.daily_limit.tooltip" class="info-icon"></span>
          </div>
          <v-select
              :searchable="false"
              :label="dailyLimitOptions.label"
              :value="dailyLimitOptions.find(item => item.value >= profile.dailyLimit)"
              :clearable="false"
              :options="dailyLimitOptions" @input="changeDailyLimit">
            <template slot="open-indicator">
              <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
              </svg>
            </template>
          </v-select>
        </div>
        <div class="progress w-100 mb-1">
          <div class="progress-label" v-if="profile.todayDailyLimit < 86400">
            <span class="text-bold text-md">{{ Math.floor(profile.dailyLimitUsed / 60) }}</span>
            <span class="text-thin">m</span>
          </div>
          <div class="progress-label" v-if="profile.todayDailyLimit < 86400">
            <span class="text-bold text-md">{{ Math.floor((profile.todayDailyLimit || profile.dailyLimit) / 60) }}</span>
            <span class="text-thin">m</span>
          </div>
          <div class="progress-percent" v-if="profile.todayDailyLimit < 86400" :style="{width: profile.dailyLimitUsed / profile.todayDailyLimit * 100 +'%' }"></div>
        </div>
        <p>{{$lang.messages.settings.daily_limit.block_description}}</p>
      </div>
      <div class="content-block-item">
        <div class="content-block-subtitle">
          {{$lang.messages.settings.unavailable.title}}
          <span v-tooltip="$lang.messages.settings.unavailable.tooltip" class="info-icon"></span>
        </div>
        <div :class="{'show-premium-popup': !isPremium}">
          <table class="table table-schedule">
            <tbody>
            <tr v-for="time in profile.availableTime" :key="time.id">
              <td class="td-checkbox"  @click="checkIfProfileActive">
                <Checkbox
                    :checkboxModel="{[time.name]:time.isActive}"
                    :disabled="isCurrentlyActiveProfile" @changecheckbox="changeschedule"
                />
              </td>
              <td class="td-day">{{time.name}}</td>
              <td class="text-center">
                <span>
                  {{time.allDay ? 'All Day' : ''}}
                  <span v-for="period in time.periods" :key="period.id" class="time-period" :class="{'-last': period.id === time.periods.length - 1 }">{{period.from}} - {{period.to}}</span>
                </span>
              </td>
              <td class="text-right"><button class="btn-icon" @click="openEditTimeModal(time)"><i class="icon-edit"></i></button></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <EditTimeModal v-if="showEditTimeModal"
                     v-on:closeedittimemodal="showEditTimeModal = false"
                     v-on:editunavailabletime="editUnavailableTime"
                     :dayId="editTimeDayId"
                     :day="editTimeDay"
                     :time="editTimeModalCurrent"
                     :additionalTime="editTimeModalCurrentAdditional"
                     :blockDay="editTimeModalBlockDay"
                     :availableTime="profile.availableTime"/>
      
    </div>
</template>

<script>
import "firebase/storage"
import 'vue-loading-overlay/dist/vue-loading.css'
import {mapState} from "vuex";
import saveSetting from '../components/mixins/saveSetting'
import Checkbox from '../components/Checkbox'
import EditTimeModal from "../components/EditTimeModal"

export default {
  name: 'ProfileLimits',
  mixins: [saveSetting],
  props: ['profileId', 'profile'],
  data: function (){
    return {
      showEditTimeModal: false,
      showGiveBonusTime: false,
      editTimeDayId: null,
      editTimeDay: null,
      editTimeModalCurrent: null,
      editTimeModalCurrentAdditional: null,
      editTimeModalBlockDay: null,
      dailyLimitOptions: [
        {
          label: '30 min',
          value: 1800,
        },
        {
          label: '1 hour',
          value: 3600,
        },
        {
          label: '1h 30m',
          value: 5400,
        },
        {
          label: '2 hours',
          value: 7200,
        },
        {
          label: '3 hours',
          value: 10800,
        },
        {
          label: '4 hours',
          value: 14400,
        },
        {
          label: 'Unlimited',
          value: 86400,
        },
      ],
    }
  },
  components: {
    Checkbox, EditTimeModal
  },
  computed: {
    ...mapState({
       user: state => state.user,
       isPremium: state => state.accountData.isPremium
    }),
    isCurrentlyActiveProfile() {
      return this.$store.getters.activeProfiles[this.profileId];
    }
  },
  methods: {
    editUnavailableTime(time){
      const previousDay = this.profile.availableTime.find(item => item.id === time.id)
      Object.assign(previousDay, time)
      this.saveProfileSettings(this.profileId, {
        availableTime: this.profile.availableTime
      })
      this.checkLockState()
      this.showEditTimeModal = false
    },
    showActiveProfileEditError() {
      this.$dtoast.pop({
        preset: 'error',
        heading: 'You can`t edit active profile time restrictions',
      });
    },

    checkIfProfileActive() {
      if (this.isCurrentlyActiveProfile) {
        this.showActiveProfileEditError();
      }
    },

    openEditTimeModal(time){
      if (this.isCurrentlyActiveProfile) {
        this.showActiveProfileEditError();
        return
      }

      switch (time.name){
        case 'Su': this.editTimeDay = 'Sunday'
          break
        case 'Mo': this.editTimeDay = 'Monday'
          break
        case 'Tu': this.editTimeDay = 'Tuesday'
          break
        case 'We': this.editTimeDay = 'Wednesday'
          break
        case 'Th': this.editTimeDay = 'Thursday'
          break
        case 'Fr': this.editTimeDay = 'Friday'
          break
        case 'Sa': this.editTimeDay = 'Saturday'
          break
      }
      this.editTimeDayId = time.id
      this.editTimeModalCurrent = time.periods || null
      this.editTimeModalBlockDay = time.allDay
      this.editTimeModalCurrentAdditional = time.periods && time.periods.length > 1 || false
      this.showEditTimeModal = true
    },
    changeschedule(day, value) {
      const temp = this.profile.availableTime.find(item => item.name === day)
      temp.isActive = value;
      this.checkLockState()
      this.saveProfileSettings(this.profileId, {
        availableTime: this.profile.availableTime
      })
    },
    checkisUnAvailableTime(unavailable) {
      const today = new Date().getTime()
      const currentDate = new Date()
      const splitedTime = (timeString) => {

        let hours
        if(timeString.split(/:| /)[2] === 'PM'){
          if(timeString.split(/:| /)[0] === '12'){
            hours = parseInt(timeString.split(/:| /)[0])
          } else {
            hours = parseInt(timeString.split(/:| /)[0]) + 12
          }
        } else {
          hours = parseInt(timeString.split(/:| /)[0])
        }
        return {
          min: parseInt(timeString.split(/:| /)[1]),
          hour: hours
          // hour: timeString.split(/:| /)[2] === 'PM' ? parseInt(timeString.split(/:| /)[0]) + 12 : parseInt(timeString.split(/:| /)[0]),
        }
      }
      let periodMainFrom, periodMainTo
      if(unavailable.periods) {
        periodMainFrom = currentDate.setHours(splitedTime(unavailable.periods[0].from).hour, splitedTime(unavailable.periods[0].from).min)
        periodMainTo = currentDate.setHours(splitedTime(unavailable.periods[0].to).hour, splitedTime(unavailable.periods[0].to).min)
      }
      if (unavailable.periods && unavailable.periods[1]) {
        const periodAddFrom = currentDate.setHours(splitedTime(unavailable.periods[1].from).hour, splitedTime(unavailable.periods[1].from).min)
        const periodAddTo = currentDate.setHours(splitedTime(unavailable.periods[1].to).hour, splitedTime(unavailable.periods[1].to).min)
        return (today > periodMainFrom && today < periodMainTo) || (today > periodAddFrom && today < periodAddTo)
      } else {
        return (today > periodMainFrom && today < periodMainTo)
      }
    },
    getDayFromDate(stamp){
      const date = new Date(stamp)
      return date.getDay()
    },
    checkLockState() {
      console.log(this.profile);
    /*  const todayDate = Date.now()
      let isUnAvailableTime = this.profile.isUnAvailableTime;
      if ((this.profile.availableTime &&
          (this.profile.availableTime[this.getDayFromDate(todayDate)].isActive && this.profile.availableTime[this.getDayFromDate(todayDate)].allDay)) ||
          (this.profile.availableTime[this.getDayFromDate(todayDate)].isActive && this.checkisUnAvailableTime(this.profile.availableTime[this.getDayFromDate(todayDate)]))) {
        isUnAvailableTime = true
      } else {
        this.checkLock = false
        isUnAvailableTime = false
      }
      if (isUnAvailableTime !== this.profile.isUnAvailableTime) {
        this.saveProfileSettings(this.profileId, {
          isUnAvailableTime: isUnAvailableTime
        })
      }*/
    },
    showPremiumPopup () {
      if(!this.isPremium){
        this.$emit('openonlypremiummodal')
      }
    },
    changeDailyLimit(value){
      this.saveProfileSettings(this.profileId, {
        dailyLimit: value.value,
        todayDailyLimit: value.value
      })
    },
  }
}
</script>



